export default {"src":"/_next/static/media/one.a9857f83.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};